'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('activation-code-seed-list', {
      url: '/admin/seed/:id',
      template: '<activation-code-seed-list></activation-code-seed-list>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/activation-code/seed/seed-list.routes.js